import { Component, OnInit, inject } from '@angular/core';
import {SharedComponentsModule} from "@well/shared-components";
import {TranslateModule} from "@ngx-translate/core";
import {
    PlatformLegalEntityInputsComponent
} from "./platform-legal-entity-inputs/platform-legal-entity-inputs.component";
import {PlatformLegalEntityDTO} from "@well/platform-administration/company/domain";
import {PlatformLegalEntityDetailPageService} from "./platform-legal-entity-detail-page.service";
import {Router} from "@angular/router";
import { LegalEntityManagementModule } from '@well/common-libs/legal-entity-management/shared';

@Component({
    selector: 'well-platform-legal-entity-detail-page',
    templateUrl: './platform-legal-entity-detail-page.component.html',
    styleUrls: ['./platform-legal-entity-detail-page.component.scss'],
    imports: [
        SharedComponentsModule,
        TranslateModule,
        LegalEntityManagementModule,
        PlatformLegalEntityInputsComponent
    ]
})
export class PlatformLegalEntityDetailPageComponent implements OnInit{
    private platformLegalEntityDetailPageService = inject(PlatformLegalEntityDetailPageService);
    private router = inject(Router);

    data: PlatformLegalEntityDTO = new PlatformLegalEntityDTO();
    ngOnInit(): void {
        this.platformLegalEntityDetailPageService.getActivePlatformLegalEntityTemplate().subscribe(
            res => this.data = res.data
        )
    }
    onSubmit(platformLegalEntityDTO: PlatformLegalEntityDTO) {
        this.platformLegalEntityDetailPageService.update(platformLegalEntityDTO).subscribe(
            res =>{
                this.data = res.data;
                this.onCancel();
            }
        )
    }

    onCancel(): void {
        this.router.navigate([`/`]);
    }

}
